<template>
  <v-card class="h-full step-card mb-2">
    <v-card-title class="pa-0">
      <span class="title">
        {{ t('landingpages.steps.results.title') }}
      </span>
    </v-card-title>
    <v-card-text class="pa-0 mt-2">
      <span class="d-flex align-center">
        <span class="view-results-icon mr-2">
          <v-icon
            width="24"
            height="24"
            color="white"
            class="mr-1 results-text-icon"
          >
            {{ type === 'GUIDE' ? 'mdi-download' : 'mdi-home-analytics' }}
          </v-icon>
        </span>
        <span class="results-text-number mr-2">{{ conversionCount }}</span>
        <span class="results-text">{{ resultText }}</span>
      </span>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  conversionCount: number
  type: string
}>()

const { t } = useI18n()

const resultText = computed(() => {
  if (props.type === 'GUIDE') return t('landingpages.steps.results.content.downloads')
  else if (props.type === 'CHECKLIST')
    return t('landingpages.steps.results.content.valued-properties')
  else return t('landingpages.steps.results.content.requests')
})
</script>

<style scoped>
.step-card {
  padding: 10px 15px 15px 15px;
  background-color: #175e51;
  border-radius: 10px;
  color: white;
}

.title {
  color: white;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
}

.view-results-icon {
  background-color: #d8f4f4;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-results-icon {
  background-color: rgba(255, 255, 255, 0.2);
}

.results-text-number {
  color: white;
  font-size: 26px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
}

.results-text-icon {
  font-size: 22px;
  padding-left: 4px;
}

.results-text {
  color: white;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  padding-top: 5px;
}
</style>
